import { render, staticRenderFns } from "./text-box-money.vue?vue&type=template&id=5e2720c9&"
import script from "./text-box-money.vue?vue&type=script&lang=js&"
export * from "./text-box-money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports